// @ts-strict-ignore
import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import { ValidatingFormComponent } from '@/formbuilder/formBuilder.constants';
import { CapsuleInput } from '@/investigate/customCondition/CapsuleInput.molecule';
import { canUseMemo, getFormFieldProps, getValidationFunction } from '@/formbuilder/formbuilder.utilities';
import { Field, useForm } from 'react-final-form';
import { Capsule } from '@/utilities/datetime.constants';
import { FormFieldWrapper } from './FormFieldWrapper';
import { Button } from '@seeqdev/qomponents';
import { useTranslation } from 'react-i18next';

export interface CapsuleInputIF extends ValidatingFormComponent<Capsule> {
  component: 'CapsuleInputFormComponent';
  trackCategory: string;
  trackAction: string;
  capsuleWindow?: Capsule;
  setCapsuleInputValidStatus?: (status) => void;
  disabled?: boolean;
  onRefreshButtonClick?: () => void;
}

const CapsuleInputFormComponentUnwrapped: React.FunctionComponent<CapsuleInputIF> = (props) => {
  const { name, validation, extendValidation, disabled, extraClassNames, testId, label, onRefreshButtonClick } = props;

  const { t } = useTranslation();
  const defaultValidation = (value) => _.isEmpty(value);
  const formState = useForm().getState();

  return (
    <div className={classNames(onRefreshButtonClick && 'width-100percent flexColumnContainer flexSpaceBetween')}>
      <FormFieldWrapper testId={testId} label={label}>
        <Field name={name} validate={getValidationFunction(defaultValidation, extendValidation, validation)}>
          {({ input, meta }) => (
            <div className={extraClassNames} id="specTrainingWindow">
              <CapsuleInput
                {...getFormFieldProps(formState, input, meta, props)}
                isDisabled={disabled}
                appendToBody={true}
              />
            </div>
          )}
        </Field>
      </FormFieldWrapper>
      {onRefreshButtonClick && (
        <Button
          icon="fa-refresh"
          extraClassNames="height-22 sq-btn-xs"
          label={t('REFRESH')}
          tooltip={t('REFRESH_WINDOW_TOOLTIP')}
          onClick={() => onRefreshButtonClick()}
        />
      )}
    </div>
  );
};

export const CapsuleInputFormComponent = React.memo(CapsuleInputFormComponentUnwrapped, canUseMemo);
